module.exports = __webpack_public_path__ + "static/media/azaelindia.888baafd.jpg";